import {template} from 'lodash';
import {markdown} from 'markdown';

const $bannerCarousel = $('#bannerCarouselTmpl');
const bannerTmpl = template($bannerCarousel.html());
let bannerContext = window.bannerContext;

/**
 * Sample context
 */
if (!bannerContext) {
  bannerContext = {
    items: [
      {
        title: 'Акция',
        background: './img/section1-bg.png',
        background_mobile: './img/section1-bg.png',
        text: `Приглашаем юных спортсменов на бесплатное занятие на единственном в России
            **суперсовременном батуте Springfree** c приставкой дополненной реальности!`,
        hasBtn: true
      },
    ]
  }
}

bannerContext.markdown = markdown;

//console.log('bannerContext: ',window.bannerContext);

//console.log(bannerTmpl(bannerContext));

if (bannerContext) {
  $bannerCarousel.replaceWith(bannerTmpl(bannerContext));
}


// WEBPACK FOOTER //
// ./src/js/banner-carousel.js